import React from 'react';
import { Button } from '../StyledComponents/StyledComponents';
import { PALETTE_3 } from '../../assets/colors';

const PrimaryButton = (props) => {
    return(
        <a href={props.route} target={props.newTab ? '_blank' : null}>
            <Button padding={"1rem 1.25rem"}color={PALETTE_3.OLDROSE} onClick={props.onClick} type={props.submit ? "submit" : "button"} right={props.right ? true : false} left={props.left ? true : false}>
                {
                    props.left
                        ?
                    <i className="las la-arrow-left"></i>
                        :
                    null
                }
                <span>{props.text}</span>
                {
                    props.right
                        ?
                    <i className={`las la-${props.newTab ? 'level-up-alt' : 'arrow-right'}`}></i>
                        :
                    null
                }
            </Button>
        </a>
    )
}

export default PrimaryButton;
